import type { IconProps } from '../types/IconProps.ts';
export const ListChevronsUpDown: IconProps = {
    name: 'ListChevronsUpDown',
    children: [
        `<path d="m14 8 3.25-2.9a.4.4 0 0 1 .5 0L21 8M14 16l3.25 2.9c.14.13.36.13.5 0L21 16M3 5h7M3 12h7M3 19h7" />`,
    ]
};